import React, { useEffect, useState } from "react";
import socket from "../../components/ScoreboardAdmin/socketClient"; // ⚠️ ajuste le chemin si besoin

const clampHalf = (v) =>
  Math.max(0, Math.min(10, Math.round(Number(v) * 2) / 2));

export default function DuoJudgePad() {
  // URL attendue : /judge?combatId=123_1&j=0
  const params = new URLSearchParams(window.location.search);
  const roomKey = params.get("room") || params.get("combatId");
  const judgeIdx = Number(params.get("j") || 0); // 0..4

  const [connected, setConnected] = useState(false);
  const [locked, setLocked] = useState(false);
  const [state, setState] = useState({
    currentTech: "A1",
    activeTeam: "red",
    ageGroup: "",
    visibleColumns: [],
  });
  const [value, setValue] = useState(0);

  useEffect(() => {
    if (!roomKey) return;

    const onConnect = () => setConnected(true);
    const onDisconnect = () => setConnected(false);

    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);

    // rejoindre la room tatami (ex: "42_3")
    socket.emit("join_combat", roomKey);

    const onState = ({ combatId: cId, state: st }) => {
      if (cId !== roomKey) return; // filtre
      setState(st || {});
      setLocked(!!st?.locked);
      setValue(0);
    };

    const onLock = ({ combatId: cId, tech, team, locked: lk }) => {
      if (cId !== roomKey) return; // filtre
      if (tech === state.currentTech && team === state.activeTeam) {
        setLocked(!!lk);
      }
    };

    socket.on("duo_state_update", onState);
    socket.on("duo_lock_manche", onLock);

    return () => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
      socket.off("duo_state_update", onState);
      socket.off("duo_lock_manche", onLock);
    };
  }, [roomKey, state.currentTech, state.activeTeam]);

  const sendNote = () => {
    if (locked || !roomKey) return;
    socket.emit("duo_judge_score", {
      combatId: roomKey, // <- on envoie la room comme "combatId"
      judgeIdx,
      tech: state.currentTech,
      team: state.activeTeam,
      value: clampHalf(value),
      ts: Date.now(),
    });
  };

  const teamName = state.activeTeam === "red" ? "Rouge" : "Bleu";
  const allowed = state.visibleColumns?.includes(state.currentTech);

  return (
    <div className="min-h-screen bg-black text-white p-4 flex flex-col items-center mt-[130px] sm:mt-[130px] md:mt-[150px] lg:mt-[150px] xl:mt-[150px]">
      <div className="w-full max-w-xl">
        <div className="text-sm opacity-70 mb-3">
          {connected ? "Connecté" : "Déconnecté"} · Room {roomKey} · Poste P
          {judgeIdx + 1}
        </div>

        <div className="bg-neutral-900 border border-neutral-800 rounded p-4 mb-4">
          <div className="text-xs opacity-70 uppercase">DuoSystem</div>
          <div className="text-2xl font-extrabold mt-1">
            Manche {state.currentTech}
          </div>
          <div className="mt-1 text-lg">
            Équipe :{" "}
            <span
              className={
                state.activeTeam === "red"
                  ? "text-red-400 font-bold"
                  : "text-blue-400 font-bold"
              }
            >
              {teamName}
            </span>
          </div>
          {!allowed && (
            <div className="mt-2 text-yellow-400">
              Manche non notée pour la catégorie sélectionnée.
            </div>
          )}
        </div>

        <div className="bg-neutral-900 border border-neutral-800 rounded p-4">
          <div className="text-center text-sm opacity-70 mb-2">
            Note P{judgeIdx + 1}
          </div>

          <div className="flex items-center justify-center gap-3 mb-3">
            <button
              className="px-5 py-4 text-2xl font-bold rounded border border-neutral-600 bg-neutral-800 hover:bg-neutral-700"
              onClick={() => setValue((v) => clampHalf(v - 0.5))}
              disabled={locked}
            >
              -0.5
            </button>

            <input
              type="number"
              min={0}
              max={10}
              step={0.5}
              className="w-40 text-center text-4xl font-extrabold bg-neutral-800 border border-neutral-700 rounded py-3"
              value={value}
              onChange={(e) => setValue(clampHalf(e.target.value))}
              disabled={locked}
            />

            <button
              className="px-5 py-4 text-2xl font-bold rounded border border-neutral-600 bg-neutral-800 hover:bg-neutral-700"
              onClick={() => setValue((v) => clampHalf(v + 0.5))}
              disabled={locked}
            >
              +0.5
            </button>
          </div>

          <div className="flex flex-wrap gap-2 justify-center mb-4">
            {[0, 5, 5.5, 7, 7.5, 8, 8.5, 9, 9.5, 10].map((v) => (
              <button
                key={v}
                className="px-4 py-2 text-xl rounded border border-neutral-600 bg-neutral-800 hover:bg-neutral-700"
                onClick={() => setValue(v)}
                disabled={locked}
              >
                {Number.isInteger(v) ? v : v.toFixed(1)}
              </button>
            ))}
          </div>

          <div className="flex items-center justify-center gap-3">
            <button
              onClick={() => setValue(0)}
              className="px-4 py-3 rounded border border-neutral-700 bg-neutral-800 hover:bg-neutral-700"
              disabled={locked}
            >
              Reset
            </button>
            <button
              onClick={sendNote}
              className={`px-6 py-3 rounded font-bold ${
                state.activeTeam === "red"
                  ? "bg-red-700 hover:bg-red-600"
                  : "bg-blue-700 hover:bg-blue-600"
              }`}
              disabled={locked || !allowed}
            >
              Valider
            </button>
          </div>

          {locked && (
            <div className="mt-3 text-center text-green-400 font-semibold">
              Manche validée. En attente…
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
